export function getEnumeration(val, arr) {
  let data;
  arr.forEach((item) => {
    if (item.value == val) {
      data = item.label;
    }
  });
  return data || val;
}
